class VideoWithText extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      videoContainer: this.querySelector("[data-video-container]"),
      video: this.querySelector("video"),
      playToggleBtn: this.querySelector("[data-video-play-button]"),
      muteToggleBtn: this.querySelector("[data-video-mute-button]"),
      playBtnText: this.querySelector("[data-play-button-text]"),
    };
  }

  connectedCallback() {
    this.elements.playToggleBtn.addEventListener(
      "click",
      this.togglePlay.bind(this)
    );

    this.elements.muteToggleBtn.addEventListener(
      "click",
      this.toggleMute.bind(this)
    );
  }

  togglePlay() {
    const playLabel = this.elements.playToggleBtn.dataset.labelPlay;
    const pauseLabel = this.elements.playToggleBtn.dataset.labelPause;

    if (this.elements.video.paused) {
      this.elements.video.play();
      this.elements.videoContainer.classList.add("is-playing");
      this.elements.playToggleBtn.setAttribute("aria-pressed", false);
      this.elements.playBtnText.innerHTML = pauseLabel;
    } else {
      this.elements.video.pause();
      this.elements.videoContainer.classList.remove("is-playing");
      this.elements.playToggleBtn.setAttribute("aria-pressed", true);
      this.elements.playBtnText.innerHTML = playLabel;
    }
  }

  toggleMute() {
    const muteLabel = this.elements.playToggleBtn.dataset.labelMute;
    const unmuteLabel = this.elements.playToggleBtn.dataset.labelUnmute;

    if (!this.elements.video.muted) {
      this.elements.video.muted = true;
      this.elements.videoContainer.classList.add("is-muted");
      this.elements.muteToggleBtn.setAttribute("aria-pressed", true);
      this.elements.muteToggleBtn.setAttribute("aria-label", unmuteLabel);
    } else {
      this.elements.video.muted = false;
      this.elements.videoContainer.classList.remove("is-muted");
      this.elements.muteToggleBtn.setAttribute("aria-pressed", false);
      this.elements.muteToggleBtn.setAttribute("aria-label", muteLabel);
    }
  }
}

if (!customElements.get("video-with-text")) {
  customElements.define("video-with-text", VideoWithText);
}
